import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from '../constants';
import type { TKeys } from './types';

const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    TITLE_1: 'Olá,',
    TITLE_2: 'O que você precisa fazer hoje?',
    HEADER_V2_DESCRIPTION:
      'Neste espaço você encontrará as principais ferramentas para o seu crescimento dentro da empresa.',
    GREETINGS: 'Bom dia, {{name}}',

    TITLE_1_MOBILE: 'Olá',

    CARDS_ENROLLED_COURSES_TITLE: 'Cursos inscritos',
    CARDS_ENROLLED_COURSES_DESCRIPTION:
      'Insira os cursos atribuídos a você e continue com seu desenvolvimento.',
    CARDS_ENROLLED_COURSES_CTA: 'Ver meus cursos',
    CARDS_LEARNING_PATHS_TITLE: 'Trilhas de aprendizagem',
    CARDS_LEARNING_PATHS_DESCRIPTION:
      'Potencialize suas habilidades com conteúdo especializado e planejado para você.',
    CARDS_LEARNING_PATHS_CTA: 'Ver minhas rotas',

    PROFILE_CARD_VIEW_PROFILE: 'Ver perfil',
    PROFILE_CARD_OCCUPATION: 'Cargo',
    PROFILE_CARD_DEPARTMENT: 'Departamento',
    PROFILE_CARD_BOSS: 'Chefe',
    PROFILE_CARD_LOCATION: 'Sede',

    TALENT_CARD_TITLE: 'Procesos de Talento',
    TALENT_CARD_TITLE_SHORT: 'Procesos de Talent',
    TALENT_CARD_DESCRIPTION:
      'Accede a guías y tutoriales para sacarle el máximo provecho a los cursos y funcionalidades de aprendizaje.',

    // Sidebar
    SIDEBAR_FOOTER_HELP: 'Ajuda',

    LABEL_SIDEBAR_ITEM_COMEBACK: 'Voltar para meus produtos',
    LABEL_SIDEBAR_ITEM_COMEBACK_SHORT: 'Volver',
    LABEL_SIDEBAR_ITEM_TITLE: 'E-Learning',
    LABEL_SIDEBAR_ITEM_START: 'Começar',
    LABEL_SIDEBAR_ITEM_CONTENT_FOR_YOU: 'Mais conteúdo',
    LABEL_SIDEBAR_ITEM_MY_COURSES: 'Meus cursos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_SEPARATOR: 'APRENDIZAGEM E PROGRESSO',
    LABEL_SIDEBAR_ITEM_MY_COURSES_ENROLLED: 'Cursos inscritos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_ENROLLED_MOBILE: 'Cursos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_SAVED: 'Cursos salvos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_TRACKS: 'Trilhas de aprendizagem',
    LABEL_SIDEBAR_ITEM_MY_COURSES_TRACKS_DETAIL: 'Trilhas de aprendizagem de',
    LABEL_SIDEBAR_ITEM_MY_COURSES_SUBTITLE:
      'Explore suas rotas atribuídas para uma aprendizagem personalizada.',
    LABEL_SIDEBAR_ITEM_MY_COURSES_NOTES: 'Apontamentos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_CERTIFICATIONS: 'Diplomas',
    LABEL_SIDEBAR_ITEM_MY_PROJECTS: 'Projetos',
    LABEL_SIDEBAR_ITEM_MY_STUDY_PLAN: 'Plano de estudos',
    LABEL_SIDEBAR_ITEM_SKILL_XP: 'Skill XP',
    LABEL_SIDEBAR_ITEM_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
    LABEL_SIDEBAR_ITEM_SKILL_XP_EVOLUTION_PENDING: 'Tests pendentes',
    LABEL_SIDEBAR_ITEM_SKILL_XP_EVOLUTION_SOLVED: 'Tests resolvidos',
    LABEL_SIDEBAR_ITEM_SKILL_XP_SEPARATOR: 'AVALIAÇÃO E CONQUISTAS',
    LABEL_SIDEBAR_ITEM_MENTORS: 'Mentorias',
    LABEL_SIDEBAR_ITEM_BLOG: 'Blog',
    LABEL_SIDEBAR_ITEM_LIVES: 'Lives',
    LABEL_SIDEBAR_ITEM_TOOLS: 'Ferramentas',
    LABEL_SIDEBAR_ITEM_PLAYROOM_ACHIEVEMENTS: 'Conquistas',
    LABEL_SIDEBAR_ITEM_PLAYROOM_REWARDS: 'Recompensas',
    LABEL_SIDEBAR_ITEM_PLAYROOM_TAB: 'Gamificação',

    SOCIAL_HUB_CARD_TITLE: 'Notícias',
    SOCIAL_HUB_CARD_CTA: 'Ler notícia',
    SOCIAL_HUB_CARD_PUBLISH_DATE: 'Publicado em {{date}}',
    SOCIAL_HUB_CARD_EMPTY_TITLE: 'Pronto sua empresa publicará suas notícias',
    SOCIAL_HUB_CARD_EMPTY_DESCRIPTION:
      'Enquanto isso, inspire-se com artigos relevantes para sua jornada profissional.',
    SOCIAL_HUB_CARD_EMPTY_BUTTON: 'Ir ao blog de Crehana',
    SOCIAL_HUB_CARD_ERROR_TITLE: 'Ocorreu um erro no carregamento',
    SOCIAL_HUB_CARD_ERROR_DESCRIPTION:
      'Clique no botão para tentar carregar novamente.',
    SOCIAL_HUB_CARD_ERROR_CTA: 'Tentar novamente',

    LEARNING_CARD_TITLE: 'Continue seu aprendizado',

    // Widgets fetching errors
    ERROR_FETCHING_LEARNING_PATHS: 'Ocorreu um erro no carregamento',
    ERROR_FETCHING_COURSES: 'Ocorreu um erro no carregamento',
    ERROR_FETCHING_LAST_ACTIVITY: 'Ocorreu um erro no carregamento',
    GRID_WIDGETS_EMPTY_STATE_TITLE: 'Não foi possível carregar o conteúdo',
    GRID_WIDGETS_EMPTY_STATE_DESCRIPTION:
      'Ocorreu um problema com a consulta ou a configuração não é reconhecida por alguma razão. Por favor, contate seu administrador ou suporte técnico para revisar e resolver este problema',

    // Error widget translations
    ERROR_WIDGET_TITLE: 'Ocorreu um erro',
    ERROR_WIDGET_MESSAGE: 'Clique no botão para tentar carregar novamente.',
    ERROR_WIDGET_RETRY_BUTTON: 'Tentar novamente',

    USERS: 'Usuários',
    SEARCH_USER_INPUT_PLACEHOLDER: 'Buscar',
    HOLIDAY_DETAIL_TABLE_COLUMN_NAME: 'Nome',
    HOLIDAY_DETAIL_TABLE_COLUMN_JOB_CATEGORY: 'Cargo',
    HOLIDAY_DETAIL_TABLE_COLUMN_AREA: 'Área',
    HOLIDAY_DETAIL_TABLE_COLUMN_COUNTRY: 'País',

    HOLIDAY_DETAIL_MODAL_TITLE: 'Detalhes do feriado',
    HOLIDAY_DETAIL_MODAL_TITLE_DESCRIPTION:
      'Visualiza aqui os usuários que correspondem à regra estabelecida para acessar este feriado.',
    HOLIDAY_DETAIL_MODAL_INFO:
      'Suas características de área, localização e país não atendem aos requisitos para acessar este feriado.',
    ERROR_LOADING_DAY_EVENTS: 'Não foi possível carregar o conteúdo',
    ERROR_LOADING_DAY_EVENTS_DESCRIPTION:
      'Houve um problema com a consulta. Por favor, tente novamente mais tarde.',

    GO_BACK: 'Voltar',
    RETRY: 'Tentar novamente',
    TODO_LIST_ADMIN_WIDGET_TAB_MANAGEMENT: 'Gestão',
    TODO_LIST_ADMIN_WIDGET_TAB_ALL: 'Todas',
    DATE_PREPOSITION_DE: 'de',
    DATE_PREPOSITION_DEL: 'de',

    // Annual Impact Banner
    ANNUAL_IMPACT_BANNER_TITLE:
      'Descubra e reconheça o que você construiu em 2025. Porque não foi apenas trabalho, foi a marca que você deixou.',
    ANNUAL_IMPACT_BANNER_TITLE_MOBILE: 'Descubra seu impacto 2025',
    LABEL_ANNUAL_IMPACT_BANNER_BUTTON: 'Descobrir meu impacto',

    // Annual Potential Banner
    ANNUAL_POTENTIAL_BANNER_TITLE:
      '2026 é o momento de levar tudo o que você já construiu para o próximo nível.',
    ANNUAL_POTENTIAL_BANNER_TITLE_MOBILE: '2026, seu próximo nível',

    LABEL_ANNUAL_POTENTIAL_BANNER_BUTTON: 'Desbloquear meu potencial',

    // ============ START TIME AND ATTENDANCE TRACKING CARD ============
    // It's an mvp so these keys should be removed later
    today: 'Hoje',
    check_in: 'Check in',
    lunch_break: 'Almoço',
    check_out: 'Check out',
    hours_worked: 'Horas trabalhadas',
    to_register: 'Por registrar',
    exit: 'Sair',
    start_lunch_break: 'Iniciar almuerzo',
    end_lunch_break: 'Fin almuerzo',
    register_lunch_break_toast_title: 'Você registrou corretamente',
    register_lunch_break_toast_description:
      'Agora você pode consultar os dados em seu cartão de assiduidade.',
    register: 'Registrar',
    day: 'Dia',
    place_of_marking: 'Local de marcação',
    register_time: 'Hora de registrar',
    scheduled_time: 'Hora programada',
    delay: 'Atraso',
    early_exit_time: 'Tempo antecipado',
    go_to_module: 'Ir ao módulo',
    // ============ END TIME AND ATTENDANCE TRACKING CARD ============

    // ============ START PAYROLL RECEIPTS WIDGET ============
    PAYROLL_WIDGET_TITLE: 'Recibos de folha de pagamento',
    PAYROLL_WIDGET_SUBTITLE: 'Visualize e baixe seus comprovantes de pagamento',
    PAYROLL_NEXT_PAYMENT_LABEL: 'Data do próximo pagamento',
    PAYROLL_NEXT_PAYMENT_TOOLTIP:
      'Os tempos de processamento bancário podem afetar a chegada do pagamento.',
    PAYROLL_EMPTY_TITLE: 'Você ainda não tem recibos de folha de pagamento',
    PAYROLL_EMPTY_DESCRIPTION:
      'Quando sua empresa processar a folha de pagamento, seu recibo aparecerá aqui.',
    PAYROLL_PERIOD_LABEL: 'Período',
    PAYROLL_VIEW_RECEIPT: 'Ver recibo',
    PAYROLL_DOWNLOAD: 'Baixar',
    PAYROLL_DOWNLOAD_RECEIPT_TOOLTIP: 'Baixar recibo',
    PAYROLL_TOAST_DOWNLOAD_SUCCESS:
      'O recibo em formato PDF foi baixado com sucesso.',
    PAYROLL_TOAST_DOWNLOAD_ERROR:
      'Desculpe, ocorreu um erro ao tentar baixar. Por favor, tente novamente.',
    PAYROLL_TOAST_DOWNLOAD_ERROR_DESCRIPTION: 'Por favor, tente novamente.',

    PAYROLL_ERROR_LOAD_TITLE: 'Ocorreu um erro',
    PAYROLL_ERROR_LOAD_DESCRIPTION:
      'Clique no botão para tentar carregar novamente.',
    PAYROLL_RETRY: 'Tentar novamente',

    PAYROLL_MODAL_RECEIPT_TITLE_1: 'Recibo:',
    PAYROLL_MODAL_RECEIPT_TITLE_2:
      'Período {{periodNumber}} de {{start}} a {{end}} de {{month}} de {{year}}',
    PAYROLL_MODAL_ERROR_MESSAGE: 'Ocorreu um erro',
    PAYROLL_MODAL_ERROR_DESCRIPTION:
      'Clique no botão para tentar carregar novamente.',
    PAYROLL_MODAL_RETRY: 'Tentar novamente',
    PAYROLL_CONTACT_SUPPORT:
      'Se o problema persistir, entre em contato com o suporte técnico.',
    // ============ END PAYROLL RECEIPTS WIDGET ============
  },
};

export default pt;
